import { Ship } from "../Models/ship";
import { Order } from "../Models/order";

export class VehicleShips {
  registerNumber?: string;
  orders?: Order[];
  ships:any;
}
